export const MAX_VISIBLE_DEBTS = 8;
export const lineChartColors = [
  '#006a5d',
  '#2b66b1',
  '#449889',
  '#628cc8',
  '#013d33',
  '#013d33',
  '#01838e',
  '#21428a',
  '#4eb3bd',
  '#6161ab',
  '#025661',
  '#21245e',
  '#0377be',
  '#4a3594',
  '#64a2d7',
  '#705ba7',
  '#0c4d8b',
  '#242366'
];
